/**
 * Created by savartsov on 11/23/2016.
 */

import _ from 'lodash'
import L from 'leaflet'
import Bing from 'leaflet-bing-layer'
import "mapbox-gl-leaflet";
import Rosreestr from "./Rosreestr";
import RosreestrQuarterStyle from "./RosreestrQuarterStyle.json"

export default {
    bing: function (bingKey) {
        return new Bing(bingKey);
    },

    yandex: function () {
        return L.tileLayer(
            'http://vec{s}.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU', {
                subdomains: ['01', '02', '03', '04'],
                attribution: '<a http="yandex.ru" target="_blank">Яндекс</a>',
                reuseTiles: true,
                updateWhenIdle: false
            }
        );
    },

    google: function() {
        return L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
            maxZoom: 20,
            attribution: '<a href="https://maps.google.com">&copy; Google</a>',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            zIndex: 0
        });
    },

    sputnik: function () {
        return L.tileLayer('https://tile.thunderforest.com/outdoors/{z}/{x}/{y}.png?apikey=a5cd8340172f4769a0c3478c17141c5a', {
            maxZoom: 19,
            reuseTiles: true,
            subdomains: 'ab',
            attribution: 'Maps &copy; <a href="https://www.thunderforest.com/">Thunderforest</a>, Data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            zIndex: 0
        });
    },

    esriTopo: function (layers) {
        return L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
            maxZoom: 20,
            reuseTiles: true,
            attribution: '© <a href="https://www.arcgis.com/">ESRI</a>',
            zIndex: 0
        });
    },

    esriImagery: function (layers) {
        return L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            maxZoom: 20,
            reuseTiles: true,
            attribution: '© <a href="https://www.arcgis.com/">ESRI</a>',
            zIndex: 0
        });
    },

    hillshade: function () {
        return L.tileLayer('https://services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}', {
            maxZoom: 20,
            reuseTiles: true,
            attribution: '© <a href="https://www.arcgis.com/">ESRI</a>',
            zIndex: 0
        });
    },

    labels: function () {
        return L.tileLayer(
            'https://{s}.tile.osm.kosmosnimki.ru/kosmohyb/{z}/{x}/{y}.png',
            {
                zIndex: 9,
                maxZoom: 18,
                attribution: '<a href="http://osm.kosmosnimki.ru/" target="_blank">ScanEx</a>',
                subdomains: 'abcd'
            }
        );
    },

    rosreestr: function (layers) {
        layers = layers || '0,1,2,3,4,5,6,7,8,9,10';

        return L.tileLayer.wms("https://pkk.rosreestr.ru/arcgis/rest/services/PKK6/CadastreObjects/MapServer/export", {
            maxZoom: 20,
            transparent: true,
            format: 'PNG32',
            layers: layers,
            imageSR: '102100',
            bboxSR: '102100',
            size: '1024,1024',
            tileSize: L.point(1024, 1024),
            f: 'image',
            cadastreLayer: true,
            cadastreType: Rosreestr.FeatureTypes.LandPlots,
            reuseTiles: true,
            attribution: 'ПКК © <a href="https://pkk.rosreestr.ru/">Росреестр</a>',
            zIndex: 100
        });
    },

    rosreestrSpesialZones:function(layers){
        layers = layers || '3,4,5,6';
        return L.tileLayer.wms("https://pkk.rosreestr.ru/arcgis/rest/services/PKK6/ZONES/MapServer/export", {
            maxZoom: 20,
            dpi: 96,
            transparent: true,
            format: 'PNG32',
            imageSR: '102100',
            bboxSR: '102100',
            size: '1024,1024',
            tileSize: L.point(1024, 1024),
            f: 'image',
            cadastreLayer: true,
            cadastreType: Rosreestr.FeatureTypes.SpecialAreas,
            reuseTiles: true,
            attribution: 'ПКК © <a href="https://pkk.rosreestr.ru/">Росреестр</a> 2010-2015',
            zIndex: 100
        });
    },

    rosreestrSelected: function (id, layers) {
        layers = layers || '0,1,2,3,4,5,6,7,8,9,10';
        let layerDefs = {};
        _.each(layers.split(','), layer => layerDefs[layer] = "ID = '" + id + "'");

        return L.tileLayer.wms("https://pkk.rosreestr.ru/arcgis/rest/services/PKK6/CadastreSelected/MapServer/export", {
            maxZoom: 20,
            transparent: true,
            format: 'PNG32',
            version: '1.1.1',
            layers: layers,
            layerDefs: JSON.stringify(layerDefs),
            imageSR: '102100',
            bboxSR: '102100',
            size: '1024,1024',
            tileSize: L.point(1024, 1024),
            f: 'image',
            cadastreLayer: true,
            reuseTiles: true,
            attribution: 'ПКК © <a href="https://pkk.rosreestr.ru/">Росреестр</a> 2010-2015'
        });
    },

    rosreestrQuarter: function () {
        RosreestrQuarterStyle.sprite = RosreestrQuarterStyle.sprite.replace("..", Rosreestr.ResourcesUrl)
        RosreestrQuarterStyle.glyphs = RosreestrQuarterStyle.glyphs.replace("..", Rosreestr.ResourcesUrl)

        // В стиле слоя указан относительный url источника
        delete RosreestrQuarterStyle.sources.esri.url;
        RosreestrQuarterStyle.sources.esri.tiles = ["https://pkk.rosreestr.ru/arcgis/rest/services/Hosted/caddivsion/VectorTileServer/tile/{z}/{y}/{x}.pbf"];

        return L.mapboxGL({
            accessToken: "",
            style: RosreestrQuarterStyle,
            pane: "rosreestrQuarterPane"
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/BaseLayers.js